<div class="subheader with-padding flgrow" style="position: relative">
  <div class="row align-items-center">
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8 maxw600">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblQuicksearch' | translate }}"
              [(ngModel)]="searchTerm" autocomplete="off" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary" (click)="onQuickSerch()">
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="ml-3 advanced-search-box">
          <button type="button" class="btn btn-primary" (click)="onSearch()" aria-label="Center Align">
            <i class="fa fa-search-plus" aria-hidden="true"></i>
          </button>
          <div class="searchbox card fix rt" *ngIf="isAdvanceSearch">
            <div class="form-row mt-3 mb-4">
              <div class="col">
                <label translate>lblAppointmentStatus</label>
                <select class="form-control" name="id" [(ngModel)]="CustomerPickDropData.appointmentStatusId">
                  <option selected translate [ngValue]="null">
                    lblSelectStatus
                  </option>
                  <option *ngFor="let status of appointmentstatusList" [ngValue]="status.id">
                    {{ status.name }}
                  </option>
                </select>
              </div>
              <div class="col">
                <label translate>lblWorkOrderStatus</label>
                <select class="form-control" name="id" [(ngModel)]="CustomerPickDropData.WorkOrderStatusId">
                  <option selected translate [ngValue]="null">
                    lblSelectStatus
                  </option>
                  <option *ngFor="let workOrderStatus of workOrderStatusList" [ngValue]="workOrderStatus.id">
                    {{ workOrderStatus.status }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-row">
              <div class="col-12">
                <label translate>lblBookedDate</label>
                <div class="date">
                  <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                  [(ngModel)]="bookingDate" (ngModelChange)="onChange($event)" required/>
                </div>
              </div>
              <div class="col-12">
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col text-right">
                <button type="submit" (click)="AdvanceSearchSubmit()" class="btn btn-primary mr-sm-2" translate>
                  lblApply
                </button>
                <button (click)="onReset()" class="btn btn-outline-tertiary mr-sm-2" translate>
                  lblReset
                </button>
                <button (click)="onClose()" class="btn btn-outline-tertiary mr-sm-2" translate>
                  lblClose
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-6 pl-4" *ngIf="dealerList && dealerList.length > 1">
      <div class="lbl-info" style="width: 100%">
        <ng-select class="" (change)="onDealerChange($event)" [(ngModel)]="selectedDealer" name="dealerId"
          placeholder="{{ 'lblSelectDealer' | translate }}">
          <ng-option *ngFor="let dealer of dealers" [value]="dealer.dealerId">
            {{ dealer.name }}
          </ng-option>
        </ng-select>
      </div>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-6">
      <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus"
        (change)="onStatusChange($event)"  >
        <ng-option *ngFor="let status of workOrderStatusList" [value]="status.id">
          {{ status.status }}
        </ng-option>
      </ng-select>
    </div>
    <div
      class="col-xl-5 col-lg-5 col-md-12 relative flmid mt-3 mt-lg-0 justify-content-md-end justify-content-lg-start">
      <button type="submit" (click)="onClickChangeView(false)" [ngClass]="
        isTodayViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'
      " class="mr-sm-2" translate>
        lblSATodayView
      </button>
      <button (click)="onClickChangeView(true)" [ngClass]="isWeekViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'"
        class="" translate>
        lblSAWeekView
      </button>
      <div
        class="col-xl-4 col-md-7 col-lg-6 d-flex align-items-center flex-sm-row flex-column justify-content-end ml-auto">
        <button type="button" (click)="exportAsXLSX(documentTypes.Excel)" ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom"
          aria-label="Center Align">
          <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
        </button>
        <button class="ml-2 btn btn-link icon-pdf" type="button" (click)="onDownloadPDF(documentTypes.Pdf)"
          ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
          <em class="far fa-file fa-2x"></em>
          <span class="bdg">PDF</span>
        </button>
        <a class="ml-3 btn btn-outline-primary" href="javascript:void(0);" (click)="refresh()"
          aria-label="Center Align">
          <em class="fas fa-sync fa-lg"></em>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex" translate>lblCustomerPick/Drop</div>
        <div class="table-responsive max-h357" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th style="width: 15%" scope="col" translate class="text-center">
                  lblWoStatus
                </th>

                <th style="width: 15%" scope="col" translate>lblWoNo</th>
                <th style="width: 20%" scope="col" sortable="" (sort)="onSort($event)" translate>
                  lblRegNumber
                </th>

                <th scope="col" sortable="customerName" (sort)="onSort($event)" translate>
                  lblCustomerName
                </th>
                <th scope="col" translate>
                  lblMobileNo
                </th>
                <th scope="col" style="width: 17%" sortable="dealerName" (sort)="onSort($event)" translate>
                  lblDealersName
                </th>
                <th style="width: 17%" scope="col" translate>lblPickupTime</th>
                <th style="width: 17%" scope="col" translate>lblDropOffTime</th>
                <th style="width: 15%" scope="col" sortable="bookedDateTime" (sort)="onSort($event)" translate>
                  lblAppointmentDate</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="CustomerVehiclePickDropResponse?.length > 0; else load_else">
                <tr *ngFor="let item of CustomerVehiclePickDropResponse; let i = index">
                  <td>{{ i+1 }}</td>
                  <td class="position-relative">
                    <div class="mx-auto text-center">
                      {{item.workOrderStatus}}
                    </div>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.workOrderNo"> </ngb-highlight>
                  </td>

                  <td>
                    <div class="flmid">
                      <div class="licplate LPNo d-flex">
                        <span class="icn-flag" [ngClass]="licensePlateClass"></span> {{ item.licensePlate }}
                      </div>
                    </div>
                    <div class="mt-1">
                      <ngb-highlight [result]="item.companyModel" class="flmid semibold fs-12px lh-16px">
                      </ngb-highlight>
                    </div>
                  </td>

                  <td>
                    <ngb-highlight [result]="item.customerName">
                    </ngb-highlight>
                   
                  </td>
                  <td>
                    <div class="d-flex align-items-center fs-12px mt-1 lh-16px">
                      <em _ngcontent-xdg-c220="" class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                      <span class="fs-12px" *ngIf="item && item.mobileCode">+{{ item.mobileCode }}-</span>
                      <ngb-highlight [result]="item.mobileNo">
                      </ngb-highlight>
                    </div>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.dealerName">
                    </ngb-highlight>
                  </td>
                  
                  <td>
                    <span>{{item.pickupTime}}</span>
                  </td>
                  <td>
                    {{ item.dropOffTime}}
                  </td>
                  <td>
                    <ngb-highlight style="margin-left: 10px;" [result]="item.bookedDate"></ngb-highlight>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <app-pagination [pager]="pager" [recordSize]="totalCount" (setPageEvent)="setPage($event)"></app-pagination>
            <div class="d-flex align-items-center justify-content-between font17 fontbold">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{totalCount}}&nbsp;<span
                class="font17 fontnormal" translate>lblResults</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>










<!-- ------------------------------------------ Pdf -------------------------------------------- -->

<div class="container prel" style="display: none; margin-top: 300px; background-color: blue;">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex" translate>lblCustomerPick/Drop</div>
        <div class="table-responsive max-h357" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
          <table class="tablest1" id="customerPdf">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th style="width: 15%" scope="col" translate class="text-center">
                  lblWoStatus
                </th>

                <th style="width: 15%" scope="col" translate>lblWoNo</th>
                <th style="width: 20%" scope="col" sortable="" (sort)="onSort($event)" translate>
                  lblRegNumber
                </th>

                <th scope="col" sortable="customerName" (sort)="onSort($event)" translate>
                  lblCustomerName
                </th>
                <th scope="col" translate>
                  lblMobileNo
                </th>
                <th scope="col" style="width: 17%" sortable="dealerName" (sort)="onSort($event)" translate>
                  lblDealersName
                </th>
                <th style="width: 17%" scope="col" translate>lblPickupTime</th>
                <th style="width: 17%" scope="col" translate>lblDropOffTime</th>
                <th style="width: 15%" scope="col" sortable="bookedDateTime" (sort)="onSort($event)" translate>
                  lblAppointmentDate</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="CustomerVehiclePickDropDocumentResponse?.length > 0; else load_else">
                <tr *ngFor="let item of CustomerVehiclePickDropDocumentResponse; let i = index">
                  <td>{{ item.No }}</td>
                  <td class="position-relative">
                    <div class="mx-auto text-center">
                      {{item.WoStatus}}
                    </div>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.WoNo"> </ngb-highlight>
                  </td>

                  <td>
                    <div class="flmid">
                      <div class="licplate LPNo d-flex">
                        <span class="icn-flag" [ngClass]="licensePlateClass"></span> {{ item.RegistrationNo }}
                      </div>
                    </div>
                  </td>

                  <td>
                    <ngb-highlight [result]="item.CustomerName">
                    </ngb-highlight>
                   
                  </td>
                  <td>
                    <div class="d-flex align-items-center fs-12px mt-1 lh-16px">
                      <em _ngcontent-xdg-c220="" class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                      <span class="fs-12px" *ngIf="item && item.MobileCode">+{{ item.MobileCode }}-</span>
                      <ngb-highlight [result]="item.MobilNo">
                      </ngb-highlight>
                    </div>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.DealerName">
                    </ngb-highlight>
                  </td>
                  
                  <td>
                    <span>{{item.CustomerPickUpTime}}</span>
                  </td>
                  <td>
                    <span>{{item.DropOffTime}}</span>
                  </td>
                  <td>
                    <ngb-highlight style="margin-left: 10px;" [result]="item.AppointmentDate"></ngb-highlight>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <app-pagination [pager]="pager" [recordSize]="totalCount" (setPageEvent)="setPage($event)"></app-pagination>
            <div class="d-flex align-items-center justify-content-between font17 fontbold">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{totalCount}}&nbsp;<span
                class="font17 fontnormal" translate>lblResults</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
